import { render, staticRenderFns } from "./CopyModal.vue?vue&type=template&id=a4bf0e34"
import script from "./CopyModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopyModal.vue?vue&type=style&index=0&id=a4bf0e34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports